import { NumberField } from '@backstage/ui';
import { numberKeyword, type SchemaObject } from './schema';

// Tiré de `odooProjectForm/CapacityEditor.tsx` à l'étape 9c du plan
// « plateforme d'applications » : l'onglet « Configuration » (le cœur) et le
// formulaire de création (Odoo) l'utilisent tous deux.

/** A number with its unit inside the box, and its human reading beside. */
export function NumberInput(props: {
  schema: SchemaObject | undefined;
  value: number | undefined;
  unit: string;
  human?: string;
  labelledBy: string;
  describedBy?: string;
  invalid: boolean;
  isDisabled: boolean;
  /** react-aria's: `snap` (default) clamps and snaps even a given value. */
  commitBehavior?: 'snap' | 'validate';
  onChange: (value: number | undefined) => void;
}) {
  const { schema } = props;
  return (
    <span className="waadoo-sf-num">
      <span className="waadoo-sf-num__box" data-unit={props.unit || undefined}>
        <NumberField
          aria-labelledby={props.labelledBy}
          aria-describedby={props.describedBy}
          value={props.value ?? NaN}
          minValue={numberKeyword(schema, 'minimum')}
          maxValue={numberKeyword(schema, 'maximum')}
          step={numberKeyword(schema, 'multipleOf') ?? 1}
          formatOptions={{ useGrouping: false }}
          onChange={next => props.onChange(isNaN(next) ? undefined : next)}
          isInvalid={props.invalid}
          // Invalid for assistive technology only: with react-aria's default
          // native validation the input would block the form's submit, even on
          // errors RJSF keeps until the next submit — a step that cannot be left.
          validationBehavior="aria"
          isDisabled={props.isDisabled}
          commitBehavior={props.commitBehavior}
        />
        {props.unit && (
          <span className="waadoo-sf-num__unit" aria-hidden="true">
            {props.unit}
          </span>
        )}
      </span>
      {props.human && (
        <span className="waadoo-sf-num__human">{props.human}</span>
      )}
    </span>
  );
}
